
import { generate } from '../../../core/js/utils/componentUtils';

import {
    isEscPressed
} from '../../../core/js/utils/keyUtils';

export function init(store, overrides = {}) {
    const config = {
        name: 'tooltipComponent',
        target: '.js-has-tooltip',
        attachEvents: attachEvents
    };
    return generate(config, store, overrides);
}

export function attachEvents(store) {
    $(document).on({
        'touchend click': (e) => false,
        'focus mouseover': showTooltip,
        'blur mouseout': hideTooltip
    }, this.target);
}

/**
 * Accessibility: blur (focusout) tooltip when `esc` key is pressed
 */
export function handleEscKey(e) {
    if (isEscPressed(e)) {
        $(this.target).blur();
    }
}

/**
 * Accessibility: set aria-hidden="false" and bind handleEscKey
 */
export function showTooltip(e) {
    $(this).find('.js-tooltip')
        .attr('aria-hidden', 'false');
    $(document).on('keyup', handleEscKey);
}

/**
 * Accessibility: set aria-hidden="true" and unbind handleEscKey
 */
export function hideTooltip(e) {
    $(this).find('.js-tooltip')
        .attr('aria-hidden', 'true');
    $(document).off('keyup', handleEscKey);
}
